import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { EnvironmentConfigService } from '../environment';
import * as i0 from "@angular/core";
import * as i1 from "../environment/environment-config.service";
import * as i2 from "@angular/common/http";
export class UserPreferencesAPIService {
    constructor(environmentConfigService, http) {
        this.environmentConfigService = environmentConfigService;
        this.http = http;
        this.apiPath = '/application-user-preference-service/v1';
        const envConfigs = this.environmentConfigService.getEnvironmentConfigs();
        this.apiUrl = envConfigs.apis.platform.url + this.apiPath;
    }
    updateUserPreference(request) {
        const url = `${this.apiUrl}/applicationuserpreference`;
        return this.http
            .put(url, request)
            .pipe(map(response => response.applicationUserPreference));
    }
    deleteUserPreference(request) {
        const url = `${this.apiUrl}/applicationuserpreference`;
        return this.http.request('delete', url, { body: request });
    }
    listUserPreferences(request) {
        const url = `${this.apiUrl}/applicationuserpreferences:list`;
        return this.http
            .post(url, request)
            .pipe(map(response => response.applicationUserPreferences));
    }
}
UserPreferencesAPIService.ngInjectableDef = i0.defineInjectable({ factory: function UserPreferencesAPIService_Factory() { return new UserPreferencesAPIService(i0.inject(i1.EnvironmentConfigService), i0.inject(i2.HttpClient)); }, token: UserPreferencesAPIService, providedIn: "root" });
